import React, {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import { useTranslation } from 'react-i18next';
import SwitchButton from '../../../../../../components/switch-button';
import Button from '../../../../../../components/button';
import {
	activateDirectorySync, isActivatingDirectorySync as setIsActivatingDirectorySync
} from '../../../../../../../actions/directoryGroupActions';
import DirectoryLedIcon from './components/directory-led-icon';
import {withRouter} from "react-router-dom";
import Icon from '../../../../../../components/icon';
import './index.css';
import {isDirectoryV5AccessPopupShown} from '../../../../../../../actions/popupActions';

function DirectorySyncModeChoice ({history}) {

	const [active, setActive] = useState(false);
	const { t } = useTranslation();

	const selectedContactsGroup = useSelector(state => state.contactsGroupItemReducer.getSelectedContactsGroup);
	const isActivatingDirectorySync = useSelector(state => state.directoryGroupReducer.isActivatingDirectorySync);
	const profile = useSelector( state => state.profileReducer.getProfile);

	const dispatch = useDispatch();

	const handleClick = () => {
		setActive(!active);
	};

	const handleStartSync = () => {
		if(profile.accessStatus.isCustomSchemaAndDirectoryWriteGranted === false){
			dispatch(isDirectoryV5AccessPopupShown(true));
		} else {
			dispatch(activateDirectorySync('DIRECTORY_LED', history));
			dispatch(setIsActivatingDirectorySync(true));
		}
	};

	return (
		<div className="directory-sync-mode-choice p-3">
			<div className="d-flex align-items-top">
				<svg className="directory-contact-icon mr-3" xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" xmlSpace="preserve">
					<path fill="#001593" d="M24 0C10.745 0 0 10.745 0 24c0 13.255 10.745 24 24 24 13.255 0 24 -10.745 24 -24C48 10.745 37.255 0 24 0z"/>
					<path d="M11.654 13.708h2.483v25.362h-2.483zm22.209 0h2.482v25.362h-2.482zm-18.284 25.362H20.554V34.673h6.892v4.397h4.974V8.93H15.579v30.139zm12.907 -28.126h2.487v2.764h-2.487v-2.764zm0 4.249h2.487v2.758h-2.487v-2.758zm0 4.243h2.487v2.764h-2.487v-2.764zm0 4.249h2.487v2.764h-2.487v-2.764zm0 4.778h2.487v2.758h-2.487v-2.758zm-3.82 -17.519h2.487v2.764h-2.487v-2.764zm0 4.249h2.487v2.758h-2.487v-2.758zm0 4.243h2.487v2.764h-2.487v-2.764zm0 4.249h2.487v2.764h-2.487v-2.764zm0 4.778h2.487v2.758h-2.487v-2.758zm-3.82 -17.519h2.483v2.764h-2.483v-2.764zm0 4.249h2.483v2.758h-2.483v-2.758zm0 4.243h2.483v2.764h-2.483v-2.764zm0 4.249h2.483v2.764h-2.483v-2.764zm0 4.778h2.483v2.758h-2.483v-2.758zm-3.825 -17.519h2.483v2.764h-2.483v-2.764zm0 4.249h2.483v2.758h-2.483v-2.758zm0 4.243h2.483v2.764h-2.483v-2.764zm0 4.249h2.483v2.764h-2.483v-2.764zm0 4.778h2.483v2.758h-2.483v-2.758z" fill="#FFF"/>
				</svg>
				<div>
					<h2 className="mr-3">{t("textDirectorySyncAccessDeniedHeader")}</h2>
					<p className="lead text-info">{selectedContactsGroup.name}</p>
				</div>
				<div className="mt-2">
					<SwitchButton active={active} onClick={handleClick}/>
				</div>
			</div>
			{
				active
					?
					<div>
						<div className="d-flex align-items-top">
							<div>
								<div className="mb-3 text-center">
									<DirectoryLedIcon color="#007bff"/>
								</div>
								<p className="text-center"><strong>{t("textDirectoryUpdatedDetails")}</strong></p>
								<ul>
									<li>{t("textDirectoryUserPush")}</li>
									<li>{t("textDirectoryAllDetails")}</li>
								</ul>
							</div>
						</div>
						<div className="text-center p-3">
							{
								isActivatingDirectorySync
								?
									<Button disabled={true} className="btn-primary">
										<Icon animated={'pulse'} name="spinner"/>
									</Button>
								:
									<Button onClick={handleStartSync} className="btn-primary">{t("textDirectorySyncStart")}</Button>
							}
						</div>
					</div>
					:
					<div>
						<p className="lead font-weight-bold">{t("textDirectorySyncGoogleDirectory")}</p>
						<p><strong>{t("textDirectoryEnableSync")}</strong></p>
						<ul>
							<li>{t("textDirectoryShareLink")}</li>
							<li>{t("textDirectoryFindContactDetails")}</li>
							<li>{t("textDirectoryActive")}</li>
						</ul>
						<div className="text-center p-3">
							<Button className="btn-primary" onClick={handleClick}>{t("textDirectorySyncEnable")}</Button>
						</div>
					</div>
			}
		</div>
	)

}

export default withRouter(DirectorySyncModeChoice);
